import { createSlice } from '@reduxjs/toolkit';
import { navigations } from 'app/navigations';

const getFilteredNavigations = (navList = [], role) => {
  return navList.reduce((filteredArray, navItem) => {
    let newNavItem = { ...navItem };

    if (newNavItem.auth && newNavItem.auth.includes(role)) {
      filteredArray.push(newNavItem);
    } else if (newNavItem.children) {
      newNavItem.children = getFilteredNavigations(newNavItem.children, role);
      if (newNavItem.children.length > 0) {
        filteredArray.push(newNavItem);
      }
    } else if (!newNavItem.auth) {
      filteredArray.push(newNavItem);
    }

    return filteredArray;
  }, []);
};

const navigationSlice = createSlice({
  name: 'navigations',
  initialState: [...navigations],
  reducers: {
    setUserNavigation: (state, action) => {
      return [...action.payload];
    },
    getNavigationByUser: (state, action) => {
      const { user, navigations = [] } = action.payload;
      return getFilteredNavigations(navigations, user.role);
    },
  },
});

export const { setUserNavigation, getNavigationByUser } = navigationSlice.actions;
export default navigationSlice.reducer;
